import Vue from 'vue'
import Cookies from 'js-cookie'
import {v1 as uuidv1} from 'uuid';

export interface IReport {
  applicationId: 'H5'
  locale: string
  bizType: 'LIVENESS_DETECTION_H5'
  info: {
    mobileInfo: {
      userAgent: string,
    }
    detail: IReportDetail,
  }
  sdkVersion: string
  eventType: string
  eventTimestamp: number
  eventCostInMilliSeconds: number
  takePhotoTimestamp: number
}

export interface IReportDetail {
  reportUuid?: string
  userId?: any

  state?: 'PRE_CHECK' | 'RESOLVE' | 'UPLOAD'
  result?: boolean
  message?: string

  imageFileFullName?: string
  imageOrigFormat?: string
  // byte
  imageOrigSize?: number
  // px
  imageOrigWidth?: number
  imageOrigHeight?: number

  isResolved?: boolean
  // ms
  resolveTime?: number
  imageResolvedFormat?: string
  imageResolvedSize?: number
  imageResolvedWidth?: number
  imageResolvedHeight?: number

  uploadTime?: number
  transactionId?: string
  score?: number
  tryCount?: number
  returnUrl?: string
  failedReturnUrl?: string
}

function getReportUuid() {
  if (Cookies.get('REPORT_UUID')) {
    return Cookies.get('REPORT_UUID')
  }
  Cookies.set('REPORT_UUID', uuidv1())
  return Cookies.get('REPORT_UUID')
}

export function getReport(): IReport {
  return {
    applicationId: 'H5',
    locale: navigator.language,
    bizType: 'LIVENESS_DETECTION_H5',
    info: {
      mobileInfo: {
        userAgent: navigator.userAgent,
      },
      detail: {
        reportUuid: getReportUuid(),
      },
    },
    sdkVersion: `${process.env.VERSION}`,
    eventType: 'REPORT',
    eventTimestamp: -1,
    eventCostInMilliSeconds: -1,
    takePhotoTimestamp: -1,
  }
}

export async function sendReport(report: IReport, message?: string, isJump?: boolean) {
  try {
    const { data: { code } } = await Vue.prototype.$http.post('/openapi/side/v1/event-tracking', report)
  } catch (e) {
    console.log('report error', report, e)
  }
}
